const FETCH_VERSION_SUCCESS = 'app/history/FETCH_VERSION_SUCCESS'

export {
  FETCH_VERSION_SUCCESS
}
